export default __webpack_public_path__ + "static/media/urn.fe39e4d7.gif";